angular.module('vastdesk').
  controller('CreativeFormController', ['$scope', '$timeout', '$interval',
    function($scope, $timeout, $interval) {

  var selector = '#creative_demand_partner_id';
  $scope.demandPartnerId = 0;

  $scope.initDemandPartner = function(demandPartnerId) {
    $scope.demandPartnerId = demandPartnerId;
    var intervalId = $interval(function() {
      var $select = $(selector);
      if ($select.length > 0) {
        $interval.cancel(intervalId);
        $select[0].tomselect.on('change', function() {
          $scope.$apply(function() {
            $scope.demandPartnerId = $(selector).val();
          });
        });
      }
    }, 1);
  };

  $timeout(function() {
    if ($(selector).length > 0) {
      $scope.initDemandPartner($(selector).val());
    }
  }, 0);

}]);
